import {RenderingServices} from '@wallaby-ui/core';

import {I18N} from './base_link_formatter_params';
import {WallabyCoreSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';

type Params = TemplatedCellRendererParams<
  WallabyCoreSchema.components['schemas']['PatientDto']
>;

export interface BasePatientListLinkFormatterParamsReturnValue {
  id: string | number;
  label: string | undefined;
  searchParams?: {selectedTabs: string};
  titleText: string | number;
}

export function basePatientListLinkFormatterParams(
  params: Params,
  services: RenderingServices = {}
): BasePatientListLinkFormatterParamsReturnValue {
  const {intl} = services;
  const {data, value} = params;
  const label = `${value}`;

  const {id} = data;
  const titleText = `${intl?.formatMessage(I18N.OPEN_DETAIL)} - ${label}`;

  return {label, id, titleText};
}
